'use es6';

import getDisplayName from '../lib/getDisplayName';
export default ((hocName, InnerComponent) => `${hocName}(${getDisplayName(InnerComponent)})`);